import { map } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularTokenService } from '@lakshvairav/angular-token';
import { Router } from '@angular/router';
import { KeyValue } from './../../shared/key-value';
import { NgForm } from '@angular/forms';
import { AuthorizationService } from './../../shared/authorization.service';
import { Observable } from 'rxjs';
declare let $: any;

@Component({
  selector: 'student-security',
  templateUrl: 'security-decisions.component.html',

})
export class SecurityDecisionsComponent implements OnInit {
  securities: any = {};
  securities_dec_copy: any = {};
  is_submited: boolean = false;
  security_type_dd: any = {};
  security_information: any = [];
  pur_security_info: any = {}
  role: string = "";
  message: string;
  security_copy: string = '';
  category: any;
  is_approved: boolean;
  form_saved: boolean = false;
  popuplinkPath: string;
  refreshIntervalId: any;
  decision_sets: any;
  popup_clicked = false;
  security_form_sub: any;
  decision_set_sub: any;
  purchase_security_error = [];
  sell_security_error = [];
  purchase_security_no = 6;
  save_pop_closed = false;
  redirect_logout = false;
  saved_copy: any = {}; // for fields color change
  security_validation: any = {};
  treasury_repos: any = {};
  selectedTabIndex: number = 0;
  KeyValue: any = {
    error_popup_title: 'Page Error',
    page_save_error: 'Please correct the error on the page and resubmit.',
    security_popup_title: 'Save Securities Inputs',
    navigation_decision_confirm: 'The data in the quarter form has changed. Do you want to save the changes?',
    // Add other key-value pairs as needed
  };
  @ViewChild('securityForm') public securityForm: NgForm;
  constructor(private router: Router, private _tokenService: AngularTokenService,
    public authService: AuthorizationService, private KeyValueService: KeyValue) {
    this.role = this.authService.getCRole();
    this.is_approved = false;
    this.popuplinkPath = KeyValue.popuplinkPath;
    this.securities = { purchase_securities_attributes: [], sell_securities_attributes: [] }
    this.securities_dec_copy = JSON.stringify(this.securities);
    this.category = [];
    this.purchase_security_error = this.fill_map_errors(this.purchase_security_no);
    this.sell_security_error = this.fill_map_errors(30);
  }

  hasChanges(){
    if (this.authService.logoutFromDeactivate === true) {
      this.redirect_logout = true;
    }
    console.log("securities decisions has changes");
    console.log(this.securities)
    console.log('-------'+(this.securities_dec_copy !== JSON.stringify(this.securities)))
    console.log(JSON.parse(this.securities_dec_copy));
    if(this.role!="Instructor" && this.securities_dec_copy!=''){
      return this.securities_dec_copy !== JSON.stringify(this.securities);
    }else{
      return false
    }
  }

  fill_map_errors(count): any {
    const obj = []
    for (let _i = 0; _i < count; _i++) {
      obj.push([])
    }
    return obj
  }

  map_errors(obj, errors): void {
    for (let _i = 0; _i < errors.length; _i++) {
      obj[_i] = errors[_i].split(',');
    }
  }

  private getFocusableElements(modal: HTMLElement): HTMLElement[] {
    return Array.from(
      modal.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ) as HTMLElement[];
  }

  private trapFocus(modal: HTMLElement): void {
    const focusableElements = this.getFocusableElements(modal);
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
  
    // Focus the first element
    firstFocusableElement.focus();
  
    // Add event listener for Tab key
    modal.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Tab') {
        if (event.shiftKey) {
          // Shift + Tab: Move focus backward
          if (document.activeElement === firstFocusableElement) {
            event.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          // Tab: Move focus forward
          if (document.activeElement === lastFocusableElement) {
            event.preventDefault();
            firstFocusableElement.focus();
          }
        }
      }
    });
  }

  openPopup() {
    try {
      // adding multiple listeners will make the event handler func to run
      // multiple times, causing issue with item charge value. This code will
      // remove previously added handler
      let old_element = document.getElementById("deleteButtonSecurity");
      let new_element = old_element.cloneNode(true);
      old_element.parentNode.replaceChild(new_element, old_element);

      old_element = document.getElementById("cancelButtonSecurity");
      new_element = old_element.cloneNode(true);
      old_element.parentNode.replaceChild(new_element, old_element);

      old_element = document.getElementById("closeButtonSecurity");
      new_element = old_element.cloneNode(true);
      old_element.parentNode.replaceChild(new_element, old_element);

    } catch (eer) {
      console.log(eer)
    }
    let modal = document.getElementById('customPopupSecurity5');

    document.getElementById('customPopupSecurity5').style.display = 'flex';
    document.querySelector(".student-dashboard-section").classList.add('popup-active');
    if(modal) this.trapFocus(modal);
    // Handle the "OK" button click
    document.getElementById('deleteButtonSecurity').addEventListener('click', () => {
      this.submitSecurities()
      document.getElementById('customPopupSecurity5').style.display = 'none';
      document.querySelector(".student-dashboard-section").classList.remove('popup-active');
    });
    document.getElementById('cancelButtonSecurity').addEventListener('click', () => {
      document.getElementById('customPopupSecurity5').style.display = 'none';
      document.querySelector(".student-dashboard-section").classList.remove('popup-active');
    });
    document.getElementById('closeButtonSecurity').addEventListener('click', () => {
      document.getElementById('customPopupSecurity5').style.display = 'none';
      document.querySelector(".student-dashboard-section").classList.remove('popup-active');
    });
  }

  openPopupSecurity1() {
    // Display the custom popup
    document.getElementById('customPopupSecurity2').style.display = 'flex';
    document.querySelector(".student-dashboard-section").classList.add('popup-active');
    const error = this.has_error(document.getElementsByClassName('errortiptext'));
    // Handle the "OK" button click
    document.getElementById('deleteButtonSecurity2').addEventListener('click', () => {
      if (error.length === 0 && this.validate_repos_val('exclude') !== false) {
        this.submitSecurities()
        document.getElementById('customPopupSecurity2').style.display = 'none';
        document.querySelector(".student-dashboard-section").classList.remove('popup-active');
        }
      });
  
      // Handle the "Cancel" button click
    document.getElementById('cancelButtonSecurity2').addEventListener('click', () => {
      // Close the custom popup
      document.getElementById('customPopupSecurity2').style.display = 'none';
      document.querySelector(".student-dashboard-section").classList.remove('popup-active');
      this.security_copy = JSON.stringify(this.securities);
      this.securities_dec_copy = JSON.stringify(this.securities)
      this.saved_copy = JSON.parse(this.security_copy);
      this.form_saved = true;
      this.is_submited = true;
      });
  
      // Handle the "Close" button click
    document.getElementById('closeButtonSecurity2').addEventListener('click', () => {
      // Close the custom popup
      document.getElementById('customPopupSecurity2').style.display = 'none';
      document.querySelector(".student-dashboard-section").classList.remove('popup-active');
      });
  }

  //gets securities details along with purchase and sell securities
  getSecurities() {
    if(this.decision_sets && this.decision_sets.length>0){
    this.authService.get(KeyValue.api_securitiesPath, { params: { security: "true" } }).pipe(
      map(res => res)).subscribe(
        data => {
          this.sell_security_error = this.fill_map_errors(data.securities.sell_securities.length);
          this.is_approved = data.securities.is_approved
          if (this.is_approved === true) {
            setTimeout(function () {
              console.log('timeout')
            }, 500);
          }
          if (data.securities.purchase_securities[0]) {
            if (data.securities.purchase_securities[0].security_type_dd_id == null) {
              data.securities.purchase_securities[0].security_type_dd_id = '';
            }
          }
          this.security_type_dd = data.security_type_dd
          this.defineSecurities(data)
        },
        error => {
          console.log(error);
        }
      );
    }
  }

  //gets securities details along with purchase and sell securities
  get_decision_security() {
    this.authService.get(KeyValue.api_decision_securitiesPath, { params: { ins_security: "true" } }).pipe(
      map(res => res)).subscribe(
        data => {
          this.sell_security_error = this.fill_map_errors(data.securities.sell_securities.length);
          this.security_type_dd = data.security_type_dd
          this.security_information = data.security_information
          this.pur_security_info = data.pur_security_info
          this.is_approved = data.securities.is_approved
          this.defineSecurities(data)
        },
        error => {
          console.log(error);
        }
      );
  }

  //defines securities
  defineSecurities(data) {
    this.securities.id = undefined
    this.securities.work_session_id = data.current_session.id
    this.security_information = data.security_information
    this.pur_security_info = data.pur_security_info
    this.securities.sell_securities_attributes = data.securities.sell_securities
    this.security_validation = data.validation_range;
    this.treasury_repos = data.treasury_repos;
    this.category = data.category_list;

    if (data.securities.purchase_securities.length == 0) {
      this.securities.purchase_securities_attributes = []
      this.securities.purchase_securities_attributes[0] = { security_type_dd_id: '', maturity: '', amount: '', is_deleted: false }
    } else {
      this.securities.purchase_securities_attributes = data.securities.purchase_securities
    }
    this.security_copy = JSON.stringify(this.securities)
    this.securities_dec_copy = JSON.stringify(this.securities)
    this.saved_copy = JSON.parse(this.security_copy);
  }

  actual_category(category) {
    const category_present = this.securities.sell_securities_attributes.map(a => a.category);
    if (category_present.includes(category)) {
      return true;
    } else {
      return false;
    }
  }

  //adds new purchase secuirty when clicked on + button
  addNewPurchaseSecurity(event: Event) {
    console.log('addNewPurchaseSecurity');
    console.log(event.target)
    this.securities.purchase_securities_attributes.push({ security_type_dd_id: '', maturity: '', amount: '', is_deleted: false });
    this.saved_copy.purchase_securities_attributes.push({ security_type_dd_id: '', maturity: '', amount: '', is_deleted: false });

    setTimeout(() => {
      if (event.target) {
        $(event.target).parent().parent().parent().find('select').last().focus();
      }
    }, 100);
  }

  //soft deletes the purchase security
  deletePurchaseSecurity(purchase_security_index) {
    const pur_sec = this.securities.purchase_securities_attributes[purchase_security_index];
    if (this.validate_repos_val(this.security_type(pur_sec.security_type_dd_id), pur_sec) === false) {
      return;
    }
    this.purchase_security_error.splice(purchase_security_index, 1)
    this.purchase_security_error.push([])
    if (this.securities.purchase_securities_attributes.length > 1) {
      if (this.securities.purchase_securities_attributes[purchase_security_index].id == undefined) {
        this.securities.purchase_securities_attributes.splice(purchase_security_index, 1)
      } else {
        this.securities.purchase_securities_attributes[purchase_security_index].is_deleted = true
        this.purchase_security_no++;
        this.purchase_security_error.push([])
      }
    }
  }

  submit() {
    const error = this.has_error(document.getElementsByClassName('errortiptext'));
    if (error.length === 0) {
      this.openPopup();
    } else {
      this.errorPopUp();
    }
  }

  // action called by deactivate guard
  // TODO: common code for all 4 std forms
  // changes to this also shold be applied to 4 std forms
  // until the common code is extracted to a service
  submitPopup(): Observable<boolean> {
    this.form_saved = false;
    this.save_pop_closed = false;

    return new Observable<boolean>(observer => {
      const that = this;

      const refreshIntervalId = setInterval(function () {
        if (that.save_pop_closed === true) {
          that.save_pop_closed = false;
          that.redirect_logout = false;
          observer.next(false);
          observer.complete();
          clearInterval(refreshIntervalId);
        } else if (that.is_submited) {
          observer.next(that.form_saved);
          observer.complete();
          clearInterval(refreshIntervalId);
        }
        that.form_saved = false;
      }, 2000);

      this.openPopupSecurity1();

      // Ensure cleanup when the observable is unsubscribed
      return () => {
        clearInterval(refreshIntervalId);
      };
    });
  }

  isapproved() {
    if (this.role !== 'Instructor') {
      return true;
    }
  }

  //updates security after click on save changes button
  submitSecurities() {
    this.securities.is_modified = true;
    if (this.validate_repos_val('exclude') === false) {
      return;
    }
    let status = false;
    this.purchase_security_error = this.fill_map_errors(this.purchase_security_no);
    this.sell_security_error = this.fill_map_errors(this.securities.sell_securities_attributes.length);
    this.is_submited = false;
    if (this.securities.purchase_securities_attributes.length > 0) {
      for (let i = 0; i < this.securities.purchase_securities_attributes.length; i++) {
        if (this.securities.purchase_securities_attributes[i].security_type_dd_id == ""
          || this.securities.purchase_securities_attributes[i].security_type_dd_id == null) {
          if (this.securities.purchase_securities_attributes[i].id) {
            this.securities.purchase_securities_attributes[i].is_deleted = true
          } else {
            this.securities.purchase_securities_attributes.splice(i, 1);
            i--;
          }
        }
      }
    }
    this.authService.post(KeyValue.api_securitiesPath, { security: this.securities, ins_security: "true" }).pipe(
      map(res => res)).subscribe(
        data => {
          console.log(data)
          if (data.status == 200) {
            status = true;
            this.purchase_security_no = 6;
            this.is_approved = data.securities.is_approved
            this.message = 'Input saved.';
            this.securities.is_viewed = true;
            this.securities.id = data.securities.id
            this.securities.work_session_id = data.securities.work_session_id
            this.securities.sell_securities_attributes = data.securities.sell_securities
            KeyValue.flash_msg_update({ msg: this.message, type: 'success_messages' })
            this.form_saved = true;
          } else {
            this.form_saved = false;
            this.map_errors(this.purchase_security_error, data.errors_json.purchase_securities);
            this.map_errors(this.sell_security_error, data.errors_json.sell_securities);
            KeyValue.flash_msg_update({ msg: KeyValue.decision_form_error, type: 'error_messages' });
          }
          this.securities.purchase_securities_attributes = data.securities.purchase_securities
          if (this.securities.purchase_securities_attributes.length == 0) {
            this.securities.purchase_securities_attributes = [];
            this.securities.purchase_securities_attributes[0] = { security_type_dd_id: '', maturity: '', amount: '', is_deleted: false };
          }
          if (status) {
            this.security_copy = JSON.stringify(this.securities);
            this.securities_dec_copy = JSON.stringify(this.securities)
            this.saved_copy = JSON.parse(this.security_copy);
          }
          this.is_submited = true;
        },
        error => { console.log('in... api failure' + error); }
      );
  }

  ngOnInit() {
    if (this.role === 'Student') {
      console.log('..//this.decision_sets.length');
      this.authService.update_decision_set_data();
      if (this.decision_sets != undefined) this.getSecurities();

      this.decision_set_sub = this.KeyValueService.decision_sets$.subscribe(
        data => {
          this.decision_sets = data.decision_sets;
          if (this.decision_sets.length === 0 && this.role === 'Student' && this.popup_clicked === false) {
            this.popup_clicked = true;
          }
        });
    } else {
      if (this.decision_sets != undefined) this.get_decision_security();
    }

    const that = this;
    this.security_form_sub = this.KeyValueService.load_decision_forms$.subscribe(
      () => {
        setTimeout(function () {
          if (this.role === 'Student') {
            that.getSecurities();
          } else {
            that.get_decision_security();
          }
        }, 1000);
      });
    this.KeyValueService.simulation_status_update('show_simulation_link');
  }

  loadInitData() {
    console.log('securities  loading init data..');

    if (this.role === 'Student')
      this.getSecurities();
    else
      this.get_decision_security();
  }

  ngOnDestroy() {
    if (this.security_form_sub !== undefined) {
      this.security_form_sub.unsubscribe();
    }
    if (this.decision_set_sub !== undefined) {
      this.decision_set_sub.unsubscribe();
    }
  }

  setFieldColor(actual_val, default_val) {
    if (parseFloat(actual_val) === parseFloat(default_val)) {
      return 'after_save_field';
    } else if (actual_val === '') {
      return 'default_field_color';
    } else {
      return 'before_save_field';
    }
  }

  validate_security_fields(evt, field, min, max, index, security_type) {
    const ele = evt == null ? document.getElementById(field + index) : evt.target;
    const val = evt == null ? (ele as HTMLInputElement).value : evt.target.value;
    const max_val = evt == null ? max : parseFloat(evt.target.attributes.getNamedItem('max').value) || max;
    const min_val = evt == null ? min : parseFloat(evt.target.attributes.getNamedItem('min').value) || min;
    const reg = RegExp('^[0-9]*$');
    const msg = 'The ' + field + ' must be between ' + min_val + ' and ' + max_val;
    if (val === '') {
      ele.parentElement.childNodes[3].style.display = 'none';
      this.validate_repos_val(security_type);
      return;
    }
    if (index != null) {
      document.getElementById('fill_field_error' + index).style.display = 'none';
    }
    if (!reg.test(val)) {
      ele.parentElement.childNodes[3].style.display = 'block';
      ele.parentElement.childNodes[3].innerHTML = 'The entry must be an integer.';
    } else if (parseFloat(val) < min_val || parseFloat(val) > max_val) {
      ele.parentElement.childNodes[3].style.display = 'block';
      ele.parentElement.childNodes[3].innerHTML = security_type === 'Tax Exempt' && field === 'maturity' ?
        'maturity must be 60 quarters' : msg;
    } else {
      ele.parentElement.childNodes[3].style.display = 'none';
      this.validate_repos_val(security_type);
    }
  }

  validate_with_security_type(security_type, index) {
    const amount = security_type === '' ? { min: 1, max: 99 } : this.security_validation[security_type].amount;
    const maturity = security_type === '' ? { min: 1, max: 120 } : this.security_validation[security_type].maturity;
    this.validate_security_fields(null, 'amount', amount.min, amount.max, index, security_type);
    this.validate_security_fields(null, 'maturity', maturity.min, maturity.max, index, security_type);
  }

  validate_repos_val(security_type, del_pur = null) {
    if (['Treasury Bills', 'Treasury Bonds', 'Bill', 'Bond', 'exclude'].includes(security_type)) {
      let amount_sum = 0;
      let sale_sum = 0;
      for (const pur of this.securities.purchase_securities_attributes) {
        if (['Treasury Bills', 'Treasury Bonds'].includes(this.security_type(pur.security_type_dd_id)) && !isNaN(parseFloat(pur.amount))
          && pur !== del_pur && pur.is_deleted !== true) {
          amount_sum += parseFloat(pur.amount);
        }
      }
      for (const sell of this.securities.sell_securities_attributes) {
        if (['Bill', 'Bond'].includes(sell.category) && !isNaN(parseFloat(sell.sale_amount))) {
          sale_sum += parseFloat(sell.sale_amount);
        }
      }
      const diff = (amount_sum - sale_sum) > 0 ? (amount_sum - sale_sum) : 0;
      if (!((this.treasury_repos.avl_amount + diff) >= this.treasury_repos.repos_val)) {
        KeyValue.flash_msg_update({ msg: KeyValue.repos_val, type: 'error_messages' });
        return false;
      }
    }
  }

  has_error(elements) {
    const error = Array.prototype.filter.call(elements, function (element) {
      return element.style.display === 'block';
    });
    return error;
  }

  errorPopUp() {
    document.getElementById('customPopupSecurity1').style.display = 'flex';
    document.querySelector(".student-dashboard-section").classList.add('popup-active');
    // Handle the "OK" button click
    document.getElementById('deleteButtonSecurity1').addEventListener('click', () => {
      document.getElementById('customPopupSecurity1').style.display = 'none';
      document.querySelector(".student-dashboard-section").classList.remove('popup-active');
    });
    document.getElementById('closeButtonSecurity1').addEventListener('click', () => {
      document.getElementById('customPopupSecurity1').style.display = 'none';
      document.querySelector(".student-dashboard-section").classList.remove('popup-active');
    });
    const modal = document.getElementById('customPopupSecurity1');
    if (modal) {
      // modal.style.display = 'flex';
      // document.querySelector('.student-dashboard-section')?.classList.add('popup-active');
  
      // Trap focus within the modal
      this.trapFocus(modal);
    }
  }

  security_type(security_type_id) {
    const security = this.security_type_dd.filter(sec => sec.id === parseFloat(security_type_id));
    return security.length === 0 ? null : security[0].name;
  }

  selectTab(index: number): void {
    this.selectedTabIndex = index;
  }

}
